/* eslint-disable no-undef */

import { Platform, StyleSheet } from 'react-native';
import { widthInPercentage } from '../../../utils/appUtils';

export default StyleSheet.create({
  loaderImageView:{
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '1%',
    flex: 1
  },
  updatedImagestyle: {
    height: 120,
    width: 140
  },
  downarrowstyle: {
    height: 20,
    width: 20
  },
  backhomestyleMob: {
    height: 17,
    width: 17,
    marginTop: widthInPercentage(17),
    marginLeft: widthInPercentage(25)
  },
  backhomestyle: {
    height: 17,
    width: 17
  },
  backhomestyle_LAPTOP: {
    height: 17,
    width: 17
  },
  backhomestyle_LDPI: {
    height: 17,
    width: 17
  },
  backhomestyle_MDPI: {
    height: 17,
    width: 17
  },
  backhomestyle_HDPI: {
    height: 17,
    width: 17
  },
  downarrowstyleMob: {
    height: 15,
    width: 15
  },
  downarrowstyle_XHDPI: {
    height: 15,
    width: 15
  },
  rightmarkstyle: {
    height: 30,
    width: 30,
    zIndex: -9999
  },
  rightmarkstyle_LDPI: {
    height: 30,
    width: 30
  },
  rightmarkstyle_MDPI: {
    height: 15,
    width: 15
  },
  rightmarkstyle_HDPI: {
    height: 30,
    width: 30
  },
  rightmarkstyleMob: {
    height: 15,
    width: 15
  },
  rightmarkstyle_XHDPI: {
    height: 15,
    width: 15
  },
  headerTabMobMainView: {
    marginHorizontal: '5px',
    borderRadius: '5px',
    flexDirection: 'row',
    shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    marginTop: widthInPercentage(11.5)
  },
  headerTabMobMainView_LDPI: {
    marginTop: widthInPercentage(32.5)
  },
  headerTabMobMainView_MDPI: {
    marginTop: Platform.OS === 'web' ? widthInPercentage(27.5) : widthInPercentage(32.5)
  },
  headerTabMobMainView_HDPI: {
    marginTop: widthInPercentage(32.5)
  },
  updatescreenstyle: {
    height: 250,
    width: 200,
    zIndex: -1
  },
  updatescreenstyle_LDPI: {
    marginTop: 30,
    height: 137,
    width: 152
  },
  updatescreenstyle_HDPI: {
    marginTop: 30,
    height: 150,
    width: 150
  },
  updatescreenstyle_MDPI: {
    marginTop: 50,
    height: 150,
    width: 150
  },
  updatescreenstyle_XHDPI: {
    height: 200,
    width: 200
  },
  updatedImagestyleError: {
    height: 162,
    width: 162
  },
  updatedImagestyleErrorOuterView: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '1%'
  },
  updatedImagestyleErrorOuterView_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '20%'
  },
  updatedImagestyleErrorOuterView_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15%'
  },
  updatedImagestyleErrorOuterView_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '15%'
  },
  updatedImagestyleErrorOuterView_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '13%'
  },
  blockupdatedImagestyle: {
    height: 140,
    width: 142
  },
  // textHeading: {
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   textAlign: 'center',
  //   fontFamily: 'Mulish',
  //   fontSize: 35,
  //   fontWeight: '600',
  //   fontFamily: 'Mulish',
  //   marginTop: '3%',
  //   color: '#222222',
  //   lineHeight: 1.3,
  //   fontStretch: 'normal',
  //   fontStyle: 'normal',
  //   letterSpacing: 0.74
  // },
  textHeading: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 32,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: '2%',
    color: '#222222',
    lineHeight: 28,
    paddingHorizontal: '1%'
  },
  textHeading_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 30,
  },
  textStyle_XHDPI: {
    fontSize: 20
  },
  textHeading_MDPI: {
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? 24 : 34,
    lineHeight: 35
  },
  textHeading_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 26,
    fontWeight: '600',
    color: '#222222',
  },
  textHeadingupdatedscreen: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 32,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: '2%',
    color: '#222222',
    lineHeight: 39,
    paddingHorizontal: '1%'
  },
  textHeadingupdatedscreen_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 30,
    lineHeight: 28,
  },
  textHeadingupdatedscreen_MDPI: {
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? '35%' : 34,
    lineHeight: 28,
  },
  textHeadingupdatedscreen_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 26,
    fontWeight: '600',
    color: '#222222',
    lineHeight: 28,
    marginTop: '46%'
  },
  textHeadingTranSuccess: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 32,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: '2%',
    color: '#222222',
    lineHeight: 22,
    paddingHorizontal: '1%'
  },
  textHeadingTranSuccess_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 24,
    lineHeight: '1.4',
  },
  textHeadingTranSuccess_MDPI: {
    fontSize: 20,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? 59 : 34,
    lineHeight: '1.4'
  },
  textHeadingTranSuccess_LDPI: {
    lineHeight: '1.4',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 20,
    fontWeight: '600',
    color: '#222222',
    marginTop: 68,
  },
  textStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: 'bold',
  },
  TrackServicetextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'black'
  },
  TrackServicetextStyle_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'black'
  },
  TrackServicetextStyle_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'black'
  },
  TrackServicetextStyle_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyle1: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: 'red',
  },
  textStyle1_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'red'
  },
  textStyle1_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'red'
  },
  textStyle1_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'red'
  },
  textStyle1_XXHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'red'
  },
  textStyleEMI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    color: 'red',
  },
  textStyleEMI_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    marginLeft:'11%',
    fontFamily: 'Mulish',
    color: 'red',
    // marginLeft:'12%'
  },
  textStyleEMI_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    marginLeft:'11%',
    fontFamily: 'Mulish',
    color: 'red',
    // marginLeft:'19%'
  },
  textStyleEMI_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    marginLeft:'11%',
    fontFamily: 'Mulish',
    color: 'red'
  },
  textStyleEMI_XXHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'red',
    // marginLeft:'27%'
  },
  textStyle_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyle_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyle_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleMessage: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 18,
    fontFamily: 'Mulish',
  },
  textStyleMessage_LDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 16,
    fontFamily: 'Mulish',
  },
  textStyleMessage_MDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 16,
    fontFamily: 'Mulish',
  },
  textStyleMessage_HDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 16,
    fontFamily: 'Mulish',
  },
  textStyleHeading: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontWeight: 'bold',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeading_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeading_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 28,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeading_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeadingNote: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontWeight: 'bold',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeadingNote_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeadingNote_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleHeadingNote_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '600',
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleError: {
    justifyContent: 'center',
    alignItems: 'center',
    // textAlign: 'center',
    fontSize: 24,
    fontFamily: 'Mulish',
    color: 'black'
  },
  textStyleErrorATM: {
    justifyContent: 'center',
    alignItems: 'center',
    // textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: 'black'
  },
  mandatoryDataText :{
    fontSize: 11,
      marginLeft: 15,
      marginTop: 3,
      fontFamily: 'Mulish'
  },
  mandatoryDataText_LDPI :{
    fontSize: 9,
      marginLeft: 15,
      marginTop: 3,
      fontFamily: 'Mulish'
  },
  mandatoryDataText_MDPI :{
    fontSize: 9,
      marginLeft: 15,
      marginTop: 3,
      fontFamily: 'Mulish'
  },
  mandatoryDataText_HDPI :{
    fontSize: 9,
      marginLeft: 15,
      marginTop: 3,
      fontFamily: 'Mulish'
  },
  linktextStyleupdate: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 11,
    fontFamily: 'Mulish',
    paddingLeft: widthInPercentage(0.5),
    color: 'blue'
  },
  hyperLink: {
    color: 'blue',
    fontWeight: 'bold'
  },
  linktextStyleupdatemachine: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 9,
    fontFamily: 'Mulish',
    paddingLeft: widthInPercentage(0.5),
    color: 'blue'
  },
  linkView:
  {
    flexDirection: "row", alignItems: 'center', alignContent: 'center', justifyContent: "center",
  },
  textStyle_XHDPI: {
    fontSize: 20
  },
  PaymentTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 5,
    paddingHorizontal: widthInPercentage(1)
  },
  PaymentTextStyletranssucess: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 5
  },
  PaymentTextStyle_LDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 40
  },
  PaymentTextStyle_MDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 40
  },
  PaymentTextStyle_HDPI: {
    justifyContent: 'left',
    alignItems: 'left',
    textAlign: 'left',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 40
  },
  transIdAndAmtBox: {
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(25),
    marginTop: widthInPercentage(2),
    borderRadius: '5px',
    zIndex: -99999999999,
    shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    backgroundColor: 'white'
  },
  transIdAndAmtBox_MDPI: {
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(19),
    marginTop: widthInPercentage(2),
    borderRadius: '5px',
    zIndex: -99999999999,
    shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    backgroundColor: 'white'
  },
  transIdAndAmtBox_LDPI: {
    paddingVertical: widthInPercentage(2),
    marginHorizontal: widthInPercentage(15),
    marginTop: widthInPercentage(2),
    borderRadius: '5px',
    zIndex: -99999999999,
    shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    backgroundColor: 'white'
  },
  PaymentNoteTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 15,
    fontFamily: 'Mulish',
    color: '#2A4CA1',
    fontWeight: '500'
  },
  valueTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    padding: 10,
    fontSize: 22,
    fontFamily: 'Mulish',
    color: 'black'
  },
  Emailidicon: {
    padding: 10,
    height: 25,
    width: 35,
    zIndex: 999,
    left: '5%',
    backgroundColor: 'white',
    position: Platform.OS === 'web' ? null : 'absolute'
  },
  Emailidicon_XXXHDPI: {
    left: '7%'
  },
  Emailidicon_XXHDPI: {
    left: '8%'
  },
  Emailidicon_XHDPI: {
    left: '10%'
  },
  Emailidicon_HDPI: {
    left: '12%'
  },
  Emailidicon_MDPI: {
    height: 15,
    width: 27,
    left: '12%'
  },
  Emailidicon_LDPI: {
    height: 2,
    width: 27,
    left: '12%'
  },

  Updatebuttontxt: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'normal',
    paddingVertical: '10%',
    paddingHorizontal: '10%',
    //paddingTop:16,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  Updatebuttontxt_XXHDPI: { fontSize: 20 },
  Updatebuttontxt_XHDPI: { fontSize: 18 },
  Updatebuttontxt_HDPI: { fontSize: 16 },
  Updatebuttontxt_MDPI: { fontSize: 16 },
  Updatebuttontxt_LDPI: { fontSize: 14 },
  samebuttontxt: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'normal',
    paddingVertical: '0.2%',
    paddingHorizontal: '1%',
    //paddingTop:16,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  samebuttontxt_XXHDPI: { fontSize: 20 },
  samebuttontxt_XHDPI: { fontSize: 18 },
  samebuttontxt_HDPI: { fontSize: 16 },
  samebuttontxt_MDPI: { fontSize: 16 },
  samebuttontxt_LDPI: { fontSize: 14 },

  Updatebuttontxtsubmit: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'normal',
    paddingVertical: '5%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  Updatebuttontxtsubmit_XXHDPI: { fontSize: 20 },
  Updatebuttontxtsubmit_XHDPI: {
    fontSize: 18,
    fontSize: 14,
    paddingVertical: '2%'
  },
  Updatebuttontxtsubmit_HDPI: {
    fontSize: 16,
    fontSize: 14,
    paddingVertical: '2%'
  },
  Updatebuttontxtsubmit_MDPI: { fontSize: 16 },
  Updatebuttontxtsubmit_LDPI: { fontSize: 14 },

  previewscreennormal: {
    display: 'flex',
    flexDirection: 'row',
    width: '94%'
  },
  previewscreennormal_XXXHDPI: { display: 'flex', flexDirection: 'row' },
  previewscreennormal_XXHDPI: { display: 'flex', flexDirection: 'row' },
  previewscreennormal_XHDPI: { display: 'flex', flexDirection: 'column' },
  previewscreennormal_HDPI: { display: 'flex', flexDirection: 'column' },
  previewscreennormal_MDPI: { display: 'flex', flexDirection: 'column' },
  previewscreennormal_LDPI: { display: 'flex', flexDirection: 'column' },

  // mainScreen: {
  //   height: 500
  // },
  // mainScreen_XHDPI: {
  //   height: 400
  // },

  previewscreensplit: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewscreensplit_XXXHDPI: { flexDirection: 'column', alignItems: 'center' },
  previewscreensplit_XXHDPI: { flexDirection: 'column', alignItems: 'center' },
  previewscreensplit_XHDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  previewscreensplit_HDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '4%'
  },
  previewscreensplit_MDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '7%'
  },
  previewscreensplit_LDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '4%'
  },

  previewheading: {
    display: 'flex',
    // flex: 3,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // right: '0%'
  },
  previewheading_LAPTOP: {
    display: 'flex',
    // flex: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // right: '0%'
  },
  previewheading_LDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '7%'
  },
  previewheading_MDPI: { flexDirection: 'row', marginLeft: '6%' },
  previewheading_HDPI: { flexDirection: 'row', marginLeft: '5%' },
  previewheading_XHDPI: {
    flexDirection: 'row',
    //marginLeft: '40%'
  },
  previewheading_XXHDPI: { flexDirection: 'row', },
  previewheading_XXXHDPI: { flexDirection: 'row', },

  previewheadingtxt: {
    fontFamily: 'Mulish',
    fontSize: 24,
    fontWeight: '500',
    marginTop: '7%'
  },
  previewheadingtxt_XXXHDPI: { fontSize: 18, marginLeft: 0 },
  previewheadingtxt_XXHDPI: { fontSize: 18, marginLeft: 0 },
  previewheadingtxt_XHDPI: { fontSize: 18, marginLeft: 0 },
  previewheadingtxt_HDPI: { fontSize: 18, marginLeft: 0 },
  previewheadingtxt_MDPI: { fontSize: 17, marginLeft: 0 },
  previewheadingtxt_LDPI: { fontSize: 16, marginLeft: 0 },

  errorMsg: {
    fontFamily: 'Mulish',
    fontSize: 16,
    fontWeight: '500',
    color: 'red',
    textAlign: 'center'
  },

  subpreviewheadingtxt: {
    fontFamily: 'Mulish',
    fontSize: 16,
    fontWeight: '500',
    marginVertical: widthInPercentage(1),
    marginHorizontal:widthInPercentage(25)
  },
  subpreviewheadingtxt_XXXHDPI: { fontSize: 16,  marginVertical: widthInPercentage(1),
    marginHorizontal:widthInPercentage(18) },
  subpreviewheadingtxt_XXHDPI: { fontSize: 14, marginVertical: widthInPercentage(1),
    marginHorizontal:widthInPercentage(18) },
  subpreviewheadingtxt_XHDPI: { fontSize: 14,  marginVertical: widthInPercentage(1),
    marginHorizontal:widthInPercentage(18)},
  subpreviewheadingtxt_HDPI: { fontSize: 12, marginLeft: 0 },
  subpreviewheadingtxt_MDPI: { fontSize: 12, marginLeft: 0 },
  subpreviewheadingtxt_LDPI: { fontSize: 12, marginLeft: 0 },

  EditandCancelbuttonMainView: {
    display: 'flex',
    // flex: 1,
    flexDirection: 'row',
    marginTop:'0'
    // alignItems: 'flex-end',
    // justifyContent: 'flex-end',
    // marginLeft: '15%'
    //width: "100%",
  },
  EditandCancelbuttonMainView_XXXHDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '11%'
  },
  EditandCancelbuttonMainView_XXHDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '11%'
  },
  EditandCancelbuttonMainView_XHDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '7%'
  },
  EditandCancelbuttonMainView_HDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '16%'
  },
  EditandCancelbuttonMainView_MDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '16%'
  },
  EditandCancelbuttonMainView_LDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: '16%'
  },
  submitbuttonATM: {
    height: 10,
    width: 10,
    margin: 0,
    //margin: 11,
    //marginTop: 13,
    //marginRight: 0
  },
  submitbuttonOther: {
    height: 10,
    width: 10,
    // margin: 11,
    // marginTop: 13,
    marginRight: 0
  },
  editbuttonATMView: {
    height: 15,
    width: 15,
    margin: 10,
    marginRight: 0,
    marginLeft: 14,
    flexDirection: 'row',
    justifyContent: 'cener',
    marginTop: 14
  },
  editbuttonOther: {
    height: 15,
    width: 15,
    margin: 10,
    marginRight: 0,
    marginLeft: 14,
    paddingLeft: '10'
  },
  cancelbuttontxt: {
    color: '#fff',
    fontSize: 15,
    fontWeight: 'normal',
    paddingVertical: 10,
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  cancelbuttontxtmob: {
    color: 'red',
    fontSize: 14,
    fontWeight: 'normal',
    paddingVertical: 10,
    paddingHorizontal: '15%',
    paddingRight: '5%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  cancelbuttontxt_XXHDPI: { fontSize: 20 },
  cancelbuttontxt_XHDPI: { fontSize: 16 },
  cancelbuttontxt_HDPI: { fontSize: 16 },
  cancelbuttontxt_MDPI: { fontSize: 16 },
  cancelbuttontxt_LDPI: { fontSize: 14, paddingHorizontal: '4%', },

  sameastxt: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'normal',
    paddingVertical: '7%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  sameastxt_LDPI: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'normal',
    paddingVertical: '7%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  sameastxt_MDPI: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'normal',
    paddingVertical: '7%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  sameastxt_HDPI: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'normal',
    paddingVertical: '7%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  sameastxt_XXHDPI: {
    color: '#fff',
    fontSize: 12,
    fontWeight: 'normal',
    paddingVertical: '7%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
  },
  sameastxtmob: {
    color: 'red',
    fontSize: 14,
    fontWeight: 'normal',
    paddingVertical: '5%',
    paddingHorizontal: '15%',
    paddingRight: '5%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  sameastxt_XXHDPI: { fontSize: 20 },
  sameastxt_XHDPI: { fontSize: 16 },
  sameastxt_HDPI: { fontSize: 16 },
  sameastxt_MDPI: { fontSize: 16, paddingVertical: '4%', },
  sameastxt_LDPI: { fontSize: 14, paddingVertical: '10%', paddingHorizontal: '4%', },

  cancelbuttonimageupdatedata: {
    color: '#fff',
    fontSize: 14,
    fontWeight: 'normal',
    paddingVertical: '5%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  cancelbuttonimageupdatedatamob: {
    color: 'red',
    backgroundColor: 'black',
    fontSize: 14,
    fontWeight: 'normal',
    paddingVertical: '15%',
    //paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  editbuttontxt: {
    color: '#fff',
    fontSize: 15,
    fontWeight: 'normal',
    paddingVertical: 10,
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    marginTop: 0
  },
  editbuttontxtATMView: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'normal',
    paddingVertical: 10,
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    marginTop: 5
  },
  editbuttontxt_XXHDPI: { fontSize: 20 },
  editbuttontxt_XHDPI: { fontSize: 16 },
  editbuttontxt_HDPI: { fontSize: 16 },
  editbuttontxt_MDPI: { fontSize: 16 },
  editbuttontxt_LDPI: { fontSize: 14 },

  editbutton: {
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    backgroundColor: '#e77817',
    flexDirection: 'row',
    borderRadius: 10,
    textAlign: 'center',
    width: 100,
    paddingVertical: 5,
    // marginRight: 30,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    // height: 42,
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  editbuttonATM: {
    backgroundColor: '#e77817',
    justifyContent: 'center',
    flexDirection: 'row',
    borderRadius: 10,
    textAlign: 'center',
    width: 80,
    height: 43,
    //paddingVertical: '1%',
    marginRight: 30,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  editbutton_LDPI: { marginBottom: 0 },
  editbutton_MDPI: {
    marginBottom: 0,
    width: 100
  },
  editbutton_HDPI: { marginBottom: 0 },
  editbutton_XHDPI: {
    marginBottom: 0,
    width: 80
  },

  cancelbutton: {
    backgroundColor: '#e77817',
    justifyContent: 'center',
    alignItems: 'center',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    // marginBottom: 10,
    marginRight: 10,
    flexDirection: 'row',
    borderRadius: 10,
    marginLeft: 10,
    textAlign: 'center',
    width: 100,
    paddingVertical: 5,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  cancelbutton_LDPI: { marginBottom: 0, width: widthInPercentage(120) },
  cancelbutton_MDPI: {
    marginBottom: 0,
    width: 90,
    margin: 0,
  },
  cancelbutton_HDPI: {
    marginBottom: 0,
    marginRight: 24
  },
  cancelbutton_XHDPI: {
    marginBottom: 0,
    marginRight: 18,
    width: 80
  },

  sameasbutton: {
    backgroundColor: '#e77817',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'row',
    borderRadius: 10,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  sameasbutton_LDPI: { marginBottom: 0, paddingTop: 5, paddingBottom: 5, width: widthInPercentage(120) },
  sameasbutton_MDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: widthInPercentage(100),
    margin: 0,
  },
  sameasbutton_HDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    marginRight: 24
  },
  sameasbutton_XHDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    marginRight: 18,
    width: 80
  },

  removebutton:
  {
    marginHorizontal: widthInPercentage(2),
    borderRadius: 5,
    textAlign: 'center',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  Updatebutton: {
    backgroundColor: '#101d6c',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 7,
    //marginTop: 7,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  Updatebuttongrey: {
    backgroundColor: 'grey',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  Updatebutton_LDPI: { marginBottom: 0, marginTop: 1, paddingTop: 2, paddingBottom: 2, paddingVertical: '0.5%', },
  Updatebutton_MDPI: { marginBottom: 0, marginTop: 1, paddingTop: 2, paddingBottom: 2, paddingVertical: '0.5%', },
  Updatebutton_HDPI: { marginBottom: 0, marginTop: 1, paddingTop: 2, paddingBottom: 2, paddingVertical: '0.5%', },

  Updatebuttonback: {
    backgroundColor: '#101d6c',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    marginHorizontal: '5%',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    justifyContent: 'flex-start'
  },
  Updatebuttonback_LDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },
  Updatebuttonback_MDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },
  Updatebuttonback_HDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },

  Updatebuttonsubmit: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    marginHorizontal: '5%',
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    justifyContent: 'flex-end'
  },
  Updatebuttonsubmit_LDPI: {
    marginBottom: 0,
    paddingTop: 10,
    paddingBottom: 10
  },
  Updatebuttonsubmit_MDPI: {
    marginBottom: 0,
    paddingTop: 10,
    paddingBottom: 10
  },
  Updatebuttonsubmit_HDPI: {
    marginBottom: 0,
    paddingTop: 10,
    paddingBottom: 10,
    paddingVertical: '0%',
    marginBottom: 0,
    width: 100
  },
  Updatebuttonsubmit_XHDPI: {
    marginBottom: 0,
    paddingTop: 10,
    paddingBottom: 10,
    paddingVertical: '0%',
    marginBottom: 0,
    width: 100
  },

  Updatebutton1: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: 120,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  samebutton: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    borderRadius: 12,
    textAlign: 'center',
    width: widthInPercentage(100),
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  HomebuttonNew: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    //borderRadius: 12,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: 'center',
    width: 50,
    height: 40,
    paddingVertical: '3%',
    paddingHorizontal: '3%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  HomebuttonNew_XHDPI: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    //borderRadius: 12,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: 'center',
    width: 50,
    height: 40,
    paddingVertical: '6%',
    paddingHorizontal: '8%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  HomebuttonNew_LDPI: {
    paddingLeft: '10%',
    paddingRight: '14%',
    height: 27,
    width: 40,
    paddingTop: '6%',
    paddingBottom: 0
  },
  HomebuttonNew_MDPI: {
    paddingLeft: '11%',
    paddingRight: '14%',
    paddingTop: '7%',
    paddingBottom: 0,
    height: 29,
    width: 40
  },
  HomebuttonsNewMob: {
    backgroundColor: '#e77817',
    borderRadius: 10,
    textAlign: 'center',
    width: 50,
    height: 40,
    paddingVertical: '3%',
    paddingHorizontal: '3%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  HomebuttonsNew: {
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    //borderRadius: 12,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: 'center',
    width: 55,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  HomebuttonsNew_LDPI: {
    width: 45,
    paddingHorizontal: '2%',
    //paddingVertical: '10%'
  },
  HomebuttonsNew_XHDPI: {
    width: 30,
    //paddingHorizontal: '4%',
  },
  HomebuttonsNew_XXHDPI: {
    width: 50,
    paddingHorizontal: '4%',
    //paddingVertical: '8%'
  },
  HomebuttonsNew_MDPI: {
    width: 45,
    //paddingVertical: '9%'
  },
  BackbuttonsNew: {
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    //paddingTop: 10,
    //paddingBottom: 10,
    //borderRadius: 12,
    borderTopRightRadius: 10,
    borderBottomRightRadius: 10,
    textAlign: 'center',
    width: 55,
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6
  },
  BackbuttonsNew_LDPI: {
    width: 45,
    paddingHorizontal: '2%',
    //paddingVertical: '10%'
  },
  BackbuttonsNew_XHDPI: {
    width: 30,
    //paddingHorizontal: '4%',
  },
  BackbuttonsNew_XXHDPI: {
    width: 46,
    paddingHorizontal: '4%',
    //paddingVertical: '8%'
  },
  BackbuttonsNew_MDPI: {
    width: 45,
    //paddingVertical: '9%'
  },
  Updatebutton1_LDPI: { marginBottom: 15 },
  Updatebutton1_MDPI: { marginBottom: 15 },
  Updatebutton1_HDPI: { marginBottom: 15 },

  backgroundImageMainview: {
    width: '100%',
    padding: 10,
    shadowOpacity: 0.1,
    shadowRadius: 18
  },

  backgroundImagestyle: {
    resizeMode: 'contain',
    width: 200,
    height: 72
  },
  backgroundImagestyle_LDPI: {
    width: 160,
    height: 72
  },
  backgroundImagestyle_MDPI: {
    width: 160,
    height: 72
  },
  backgroundImagestyle_HDPI: {
    width: 160,
    height: 72
  },
  UpdateScreenMainView: {
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: 10,
    display: "block",
    marginHorizontal: '2%'
  },
  UpdateScreenMainViewECS: {
    flexDirection: 'column',
    alignItems: 'center',
    //marginTop: 10,
    display: "block",
    marginHorizontal: '2%'
  },
  UpdateScreenFlexView1: {
    flex: 1,
    padding: '3%',
    width: '80%',
    alignSelf: 'center',
    alignItems: 'flex-start'
  },
  UpdateScreenFlexView1_LDPI: { width: '100%', paddingBottom: '2%' },
  UpdateScreenFlexView1_MDPI: { width: '100%', paddingBottom: '2%' },
  UpdateScreenFlexView1_HDPI: { width: '100%', paddingBottom: '2%' },
  UpdateScreenFlexView1cust: {
    flex: 1,
    paddingTop: '0%',
    width: '80%',
    borderRadius: 5,
    alignSelf: 'center',
    alignItems: 'flex-start'
  },
  UpdateScreenFlexView1cust_LDPI: { paddingBottom: '2%', alignSelf: 'center', },
  UpdateScreenFlexView1cust_MDPI: { paddingBottom: '2%', alignSelf: 'center', },
  UpdateScreenFlexView1cust_HDPI: { paddingBottom: '2%', alignSelf: 'center', },
  UpdateScreenFlexView2: {
    flex: 1,
    width: '80%',
    backgroundColor: '#fff',
    alignSelf: 'center',
    alignItems: 'flex-start',
    //marginBottom: 2,
    paddingBottom: 5,
    // paddingTop: 20,
    paddingLeft: 8
  },
  UpdateScreenFlexView1customer: { paddingLeft: 'none' },
  UpdateScreenFlexView1customer_LDPI: { paddingLeft: widthInPercentage(8) },
  UpdateScreenFlexView1customer_MDPI: { paddingLeft: widthInPercentage(8) },
  UpdateScreenFlexView1customer_HDPI: { paddingLeft: widthInPercentage(8) },
  UpdateScreenFlexView2_LDPI: { width: '100%', paddingLeft: 6 },
  UpdateScreenFlexView2_MDPI: { width: '100%', paddingLeft: 8 },
  UpdateScreenFlexView2_HDPI: {
    width: '83%',
    paddingTop: 10,
    paddingBottom: 10
  },
  UpdateScreenFlexView2_XHDPI: {
    width: '83%',
    paddingTop: 10,
    paddingBottom: 10
  },
  UpdateScreenFlexView2Cust: {
    flex: 1,
    width: '80%',
    backgroundColor: '#efefef',
    alignSelf: 'center',
    alignItems: 'flex-start',
    marginBottom: 2,
    paddingBottom: 20,
    paddingTop: 20,

  },
  UpdateScreenFlexView2Cust_LDPI: { alignSelf: 'center', },
  UpdateScreenFlexView2Cust_MDPI: { alignSelf: 'center', },
  UpdateScreenFlexView2Cust_HDPI: {
    paddingTop: 10,
    paddingBottom: 10, alignSelf: 'center',
  },
  UpdateScreenFlexView2Cust_XHDPI: {
    width: '83%',
    paddingTop: 10,
    paddingBottom: 10
  },

  UpdateScreenFlexView1Text1: {
    fontSize: 15,
    fontFamily: 'Mulish',
    color: '#333',
    fontWeight: 'bold',
  },
  UpdateScreenFlexView1TextCust: {
    fontSize: 16,
    fontFamily: 'Mulish',
    fontWeight: 500,
    color: '#333'
  },
  UpdateScreenFlexView1TextCust_LDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1TextCust_MDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1TextCust_HDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1TextCust_XHDPI: { width: '100%', fontSize: 13 },
  UpdateScreenFlexView1TextCust_XXHDPI: { width: '100%' },
  UpdateScreenFlexView1Text2: {
    fontSize: 16,
    width: '100%',
    fontFamily: 'Mulish'
  },
  UpdateScreenFlexView1Text2_LDPI: { width: '100%' },
  UpdateScreenFlexView1Text2_MDPI: { width: '100%' },
  UpdateScreenFlexView1Text2_HDPI: { width: '100%' },
  UpdateScreenFlexView1Text2_XHDPI: { width: '100%', fontSize: 13 },
  UpdateScreenFlexView1Text2_XXHDPI: { width: '100%' },
  UpdateScreenFlexView1Text2Cust: {
    fontSize: 16,
    width: '100%',
    paddingHorizontal: widthInPercentage(1),
    fontFamily: 'Mulish'
  },
  UpdateScreenFlexView1Text2Cust_LDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1Text2Cust_MDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1Text2Cust_HDPI: { width: '100%', fontSize: 14 },
  UpdateScreenFlexView1Text2Cust_XHDPI: { width: '100%', fontSize: 14, },
  UpdateScreenFlexView1Text2Cust_XXHDPI: { width: '100%' },
  Update2viewsMainView: {
    flexDirection: 'row',
    zIndex: -9,
    width: '100%',
    alignSelf: 'center'
  },
  buttonView: {
    flexDirection: 'row',
    zIndex: -9,
    width: '100%',
    alignSelf: 'center'
  },
  buttonViewTableScreen: {
    flexDirection: 'row',
    zIndex: -9,
    width: '100%',
    alignSelf: 'center',
    justifyContent: 'center',
  },
  buttonView_XHDPI: {
    flexDirection: 'row',
    marginTop: widthInPercentage(1),
    zIndex: -9,
    width: '80%',
    alignSelf: 'center'
  },
  Update2viewsMainView_LDPI: { width: '100%' },
  Update2viewsMainView_MDPI: { width: '100%' },
  Update2viewsMainView_HDPI: { width: '100%' },

  Update1viewsMainView: {
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: -9,
    width: '100%',
    alignSelf: 'center'
  },
  Update1viewsMainView_LDPI: { width: '100%', paddingTop: 5 },
  Update1viewsMainView_MDPI: { width: '100%', paddingTop: 20 },
  Update1viewsMainView_HDPI: { width: '100%', paddingTop: 20 },

  UpdatebuttonMainView: {
    //width: '100%',
    display: "flex",
    flexDirection: "row",
    justifyContent: 'center',
    alignItems: 'center',
    alignContent: 'center',
    paddingTop: 0,
    marginBottom: 10,
    //marginTop: '14%'
  },
  UpdatebuttonMainView_LDPI: { paddingTop:10 },
  UpdatebuttonMainView_MDPI: {paddingBottom: 0 },
  UpdatebuttonMainView_HDPI: { paddingBottom: 0, paddingTop: 0 },
  UpdatebuttonMainView_XHDPI: { paddingBottom: 0, paddingTop: 0 },
  EditSubmitButtons: {
    marginTop:100
  },
  serviceContent: {
    // minHeight: 880,
    // width: '100%',
    display: 'flex',
    // flex: 1,
    // justifyContent: 'space-around',
    flexDirection: 'column',
    // paddingBottom: 6,
    // shadowColor: '#000',
    // shadowOffset: {
    //   width: 2,
    //   height: 2
    // },
    // shadowOpacity: 0.37,
    // shadowRadius: 8.65,
    // elevation: 6,
    // borderRadius: 8,
    // marginLeft: 20,
    marginTop: '14%',
    // marginBottom: 10,
    backgroundColor: '#ffff',
    padding: 15,
  },
  serviceContent_HDPI: {
    marginLeft: 30
  },
  serviceContent_MDPI: {
    // minHeight: 450,
    // shadowRadius: 9.65,
    // marginTop: 0,
    // paddingLeft: 8,
  },
  serviceContent_LDPI: {
    // minHeight: 450,
    // shadowRadius: 9.65,
    // marginTop: '33%'
  },
  serviceContentECS: {
    //minHeight: 880,
    width: '88%',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-around',
    flexDirection: 'column',
    paddingBottom: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowOpacity: 0.37,
    shadowRadius: 8.65,
    elevation: 6,
    borderRadius: 8,
    marginLeft: 20,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#ffff'
  },
  serviceContentECS_HDPI: {
    marginLeft: 30
  },
  serviceContentECS_MDPI: {
    // minHeight: 450,
    shadowRadius: 9.65,
    marginTop: '31%',
    paddingLeft: 8,
  },
  serviceContentECS_LDPI: {
    // minHeight: 450,
    shadowRadius: 9.65,
    marginTop: '33%'
  },
  serviceContentAtm: {
    minHeight: 324,
    width: '94%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowOpacity: 0.37,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 8,
    marginLeft: 22,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#ffff',
    maxHeight: 30,
    overflow: 'scroll'
  },
  serviceContentOtherScreens: {
    width: '90%',
    height: '100%',
    display: 'flex',
    justifyContent: 'space-around',
    flexDirection: 'column',
    alignItems: 'center',
    alignContent: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowOpacity: 0.37,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 8,
    marginLeft: '5%',
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#ffff'
  },
  serviceContentOtherScreens_XXHDPI: {
    marginLeft: 75
  },
  ContentOtherScreens: {
    width: '94%',
    display: 'flex',
    minHeight: 360
  },
  Content: {
    width: '54%',
    display: 'flex'
  },
  ContentAtm: {
    width: '94%',
    display: 'flex'
  },
  CancelbuttonMainView: {
    margin: 0,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    paddingTop: 0
  },
  CancelbuttonMainView_LDPI: { paddingBottom: 20 },
  CancelbuttonMainView_MDPI: { paddingBottom: 20 },
  CancelbuttonMainView_HDPI: { paddingBottom: 0, paddingTop: 9 },
  CancelbuttonMainView_XHDPI: { paddingBottom: 0, paddingTop: 9 },

  sameasMainView: {
    margin: 0,
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    paddingTop: 20,
    marginHorizontal: widthInPercentage(4)
  },
  sameasMainView_LDPI: { paddingBottom: 15},
  sameasMainView_MDPI: { paddingBottom: 15 },
  sameasMainView_HDPI: { paddingBottom: 0, paddingTop: 9 },
  sameasMainView_XHDPI: { paddingBottom: 0, paddingTop: 9 },

  EditbuttonMainView: {
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    paddingTop: 0
  },
  EditbuttonMainView_LDPI: { paddingBottom: 20 },
  EditbuttonMainView_MDPI: { paddingBottom: 20 },
  EditbuttonMainView_HDPI: { paddingTop: 9, paddingBottom: 0 },
  EditbuttonMainView_XHDPI: { paddingTop: 9, paddingBottom: 0 },

  UpdateerrorMessageWhiteText: {
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 18,
    color: 'white',
    fontFamily: 'Mulish',
    padding: 10,
    marginBottom: '0.5%',
    marginTop: '0.5%',
    //textAlign: 'center'
  },
  UpdateerrorMessageWhiteText_LAPTOP: {
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 18,
    color: 'white',
    fontFamily: 'Mulish',
    padding: 10,
    marginBottom: '0.5%',
    marginTop: '0.5%',
    //textAlign: 'center'
  },
  UpdateerrorMessageText: {
    justifyContent: 'center',
    alignItems: 'center',
    // fontSize: 18,
    color: 'red',
    // fontFamily: 'Mulish',
    // padding: 10,
    // marginBottom: '0.5%',
    fontSize: 14,
    fontFamily: 'Mulish',
    padding: 9,
    // marginBottom: '3%',
    marginTop: '0.5%',
    //marginTop: '0.5%',
    //textAlign: 'center'
  },
  UpdateerrorMessageText_LAPTOP: {
    justifyContent: 'center',
    alignItems: 'center',
    // fontSize: 18,
    color: 'red',
    // fontFamily: 'Mulish',
    // padding: 15,
    // marginBottom: '1%',
    fontSize: 14,
    fontFamily: 'Mulish',
    padding: 9,
    marginBottom: '0.5%',
    marginTop: '0.5%',
    //marginTop: '1%',
    //textAlign: 'center'
  },
  UpdateerrorMessageText_LDPI: {
    fontSize: 16
  },
  UpdateerrorMessageText_MDPI: {
    fontSize: 16
  },
  UpdateerrorMessageText_HDPI: {
    fontSize: 18
  },
  UpdateerrorMessageText_XHDPI: {
    fontSize: 16,
    padding: 8,
    marginBottom: '0.5%',
    marginTop: '0.5%',
  },



  CreditMessageText: {
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    fontFamily: 'Mulish',
    padding: 10,
    marginBottom: '0.5%',
    marginTop: '0.5%',
    //textAlign: 'center'
  },
  CreditMessageText_LAPTOP: {
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    fontFamily: 'Mulish',
    padding: 9,
    marginBottom: '0.5%',
    marginTop: '0.5%',
    //textAlign: 'center'
  },
  CreditMessageText_LDPI: {
    fontSize: 16
  },
  CreditMessageText_MDPI: {
    fontSize: 16
  },
  CreditMessageText_HDPI: {
    fontSize: 18
  },
  CreditMessageText_XHDPI: {
    fontSize: 16,
    padding: 8,
    marginBottom: '0.5%',
    marginTop: '0.5%',
  },
  textStyleDIY: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 24,
    fontFamily: 'Mulish',
    color: 'black',
    marginTop:'2%'
  },
  NumbertoWordText:
  {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    fontSize: 14,
    color: '#707070',
    fontFamily: 'Mulish',
    textAlign: 'flex-start',
    marginVertical: widthInPercentage(1),
    marginHorizontal: widthInPercentage(6)
  },
  updatedView: {
    justifyContent: 'center',
    alignItems: 'center'
  },

  nav: {
    position: Platform.OS === 'web' ? 'fixed' : null,
    width: '100%',
    backgroundColor: '#fff',
    zIndex: 99999
  },
  loadingViewstyle: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '1%'
  },

  loadingViewstylemob: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '10%'
  },

  loadingImagestyle: {
    width: 80,
    height: 80
  },
  loaderImageView:{
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '1%',
    flex: 1
  },
  loadingContentstyle: {
    //justifyContent: 'center',
    // alignItems: 'center',
    marginBottom: '4%',
    //marginHorizontal: '5%',
    zIndex: -9,
  },
  loadingContentstyle_XHDPI: { marginBottom: '2%' },

  displayMaxLen: {
    fontSize: 11,
    //marginVertical: '2%',
    fontFamily: 'Mulish',
    color: 'grey'
  },
  submitBtn: {
    width: '50%',
    height: 50,
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: '#e77817',
    padding: 10,
    borderRadius: 5,
    marginTop: 30
  },
  submitBtn_MDPI: {
    marginTop: 15
  },
  submitBtn_LDPI: {
    marginTop: 15
  },
  submitBtn_HDPI: {
    marginTop: 15
  },
  submitBtn_XHDPI: {
    marginTop: 15
  },
  bitlyBtn: {
    width: '15%',
    height: 50,
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: '#e77817',
    padding: 10,
    borderRadius: 5,
    marginTop: 30
  },
  bitlyBtn_MDPI: {
    marginTop: 15
  },
  bitlyBtn_LDPI: {
    marginTop: 15
  },
  bitlyBtn_HDPI: {
    marginTop: 15
  },
  bitlyBtn_XHDPI: {
    marginTop: 15
  },

  submitBtnforMobile: {
    width: '80%',
    height: 50,
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: '#e77817',
    padding: 10,
    borderRadius: 5,
    marginTop: 30,
    alignItems: 'center'
  },
  submitBtnforMobile_MDPI: {
    marginTop: 15,
    padding: 5,
  },
  submitBtnforMobile_LDPI: {
    marginTop: 15,
    padding: 10,
  },
  submitBtnforMobile_HDPI: {
    marginTop: 15,
    padding: 10,
  },
  submitBtnforMobileConfirmCustomer: {
    width: '63%',
    height: 50,
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: '#e77817',
    padding: 10,
    borderRadius: 5,
    marginTop: 30,
    alignItems: 'center'
  },
  submitBtnforMobileConfirmCustomer_MDPI: {
    marginTop: 15,
    width: '63%',
    padding: 5,
  },
  submitBtnforMobileConfirmCustomer_LDPI: {
    marginTop: 15,
    padding: 10,
  },
  submitBtnforMobileConfirmCustomer_HDPI: {
    marginTop: 15,
    padding: 10,
  },
  submitBtnforMobile_XHDPI: {
    marginTop: 15
  },
  newserviceTextForMobile: {
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 18,
    color: '#fff',
    justifyContent: 'center',
    alignItems: 'center'
  },
  newserviceText: {
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: 'bold',
    fontSize: 16,
    color: '#fff'
  },
  messageNoteContainer: {
    zIndex: -1, 
    paddingTop: '15px'
  },
  messageNoteContainer_LAPTOP: {
    marginTop: 0,
    zIndex: -1, 

  },
  messageNoteContainer_LDPI: {
    marginTop: 42
  }, 
  messageNoteContainer_MDPI: {
    marginTop: 42
  }, messageNoteContainer_XHDPI: {
    marginTop: 42
  }, messageNoteContainer_XXHDPI: {
    marginTop: 55
  }, messageNoteContainer_XXXHDPI: {
    marginTop: 42
  },
  NoteTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 10,
    marginRight: '2%'
  },
  NoteTextStyle_LDPI: {
    fontSize: 15,
  },
  NoteTextStyle_MDPI: {
    fontSize: 15,
  },
  NoteTextStyle_HDPI: {
    fontSize: 15,
  },
  NoteTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight: '500',
    paddingTop: 10
  },
  NoteTextStyle_LDPI: {
    fontSize: 15,
  },
  NoteTextStyle_MDPI: {
    fontSize: 15,
  },
  NoteTextStyle_HDPI: {
    fontSize: 15,
  },
  isblur: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: -99999,
    pointerEvents: 'none',
  },
  isblur_LDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 4
    //pointerEvents: 'none' ,
  },
  isblur_MDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 4
    //pointerEvents: 'none' ,
  },
  isblur_hDPI: {
    flexDirection: 'row',
    backgroundColor: '#808080',
    opacity: 0.1,
    zIndex: 4
    //pointerEvents: 'none' ,
  },
  NewUIBoxMain:
  {
    marginVertical: widthInPercentage(0.6), marginHorizontal: widthInPercentage(2), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,

    shadowRadius: 15
  },
  NewUIBoxMain_XHDPI:
  {
    marginTop: widthInPercentage(1), marginHorizontal: widthInPercentage(2), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,

    shadowRadius: 15
  },
  loaderImageView:
  {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '1%',
    flex: 1
  },
  buttonstyle:
  {
    marginHorizontal: widthInPercentage(20), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',

  },
  buttonstyle_LDPI: { marginHorizontal: widthInPercentage(0), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey', },

  buttonstyle_MDPI: { marginHorizontal: widthInPercentage(0), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey', },

  buttonstyle_HDPI: { marginHorizontal: widthInPercentage(0), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey', },

  buttonstyle_XHDPI: { marginHorizontal: widthInPercentage(20), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey', },

  buttonstyle_XXHDPI: { marginHorizontal: widthInPercentage(20), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey', },
  NametextStyle: { paddingBottom: widthInPercentage(1), fontFamily: 'Mulish', color: '#000000', fontSize: '26px' },
  NametextStyle_LDPI: { paddingBottom: widthInPercentage(1), fontFamily: 'Mulish', color: '#000000', fontSize: '14px' },
  NametextStyle_MDPI: { paddingBottom: widthInPercentage(1), fontFamily: 'Mulish', color: '#000000', fontSize: '14px' },
  NametextStyle_HDPI: { paddingBottom: widthInPercentage(1), fontFamily: 'Mulish', color: '#000000', fontSize: '16' },
  NametextStyle_XHDPI: { paddingBottom: widthInPercentage(1), fontFamily: 'Mulish', color: '#000000', fontSize: '16' },
  subheadingViewStyle: { marginHorizontal: widthInPercentage(0.5), marginVertical: widthInPercentage(2) },
  subheadingViewStyle_LDPI: { marginHorizontal: widthInPercentage(0.5), marginVertical: widthInPercentage(2) },
  subheadingViewStyle_MDPI: { marginHorizontal: widthInPercentage(0.5), marginVertical: widthInPercentage(4) },
  subheadingViewStyle_HDPI: { marginHorizontal: widthInPercentage(0.5), marginVertical: widthInPercentage(2) },
  subheadingViewStyle_XHDPI: { marginHorizontal: widthInPercentage(0.5), marginVertical: widthInPercentage(2) },
  subHeadingtextStyle: { color: '#000000', fontSize: '12px', fontFamily: 'Mulish' },
  subHeadingtextStyle_LDPI: { color: '#000000', fontSize: '12px', fontFamily: 'Mulish' },
  subHeadingtextStyle_MDPI: { color: '#000000', fontSize: '14px', fontFamily: 'Mulish' },
  subHeadingtextStyle_HDPI: { color: '#000000', fontSize: '18px', fontFamily: 'Mulish' },
  placeholderTextstyle: { paddingVertical: widthInPercentage(1), fontFamily: 'Mulish', color: '#707070', fontSize: '14px' },

  webflexstyle:
  {
    flex: 0.9
  },
  webflexstyle_LDPI:
  {
    flex: 0.9
  }, webflexstyle_MDPI:
  {
    flex: 0.3
  },
  webflexstyle_HDPI:
  {
    flex: 0.9
  },
  steptwoView: { marginHorizontal: widthInPercentage(7), marginVertical: widthInPercentage(1.5) },
  steptwoView_LDPI: { marginHorizontal: widthInPercentage(2), marginVertical: widthInPercentage(1.5) },
  steptwoView_MDPI: { marginHorizontal: widthInPercentage(0), marginVertical: widthInPercentage(1.5) },
  steptwoViewdots: { marginHorizontal: widthInPercentage(8), marginVertical: widthInPercentage(0) }
  ,
  steptwoViewdots_MDPI: { marginHorizontal: widthInPercentage(2), marginVertical: widthInPercentage(0) },
  headerView: {
    marginHorizontal: widthInPercentage(2), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    marginTop: widthInPercentage(1),
    height: 70
  },
  headerView_XHDPI: {
    marginHorizontal: widthInPercentage(2), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    marginTop: widthInPercentage(0.5),
    height: 50
  },
  headerView_XXHDPI: {
    marginHorizontal: widthInPercentage(2), borderRadius: '5px', flexDirection: 'row', shadowColor: 'grey',
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowOpacity: 0.2,
    shadowRadius: 15,
    marginTop: widthInPercentage(0.5),
    height: 84
  },
  ViewHeaderText:
    { color: '#000000', fontSize: '22px', fontFamily: 'Mulish' },
  ViewHeaderText_XHDPI:
    { color: '#000000', fontSize: '14px', fontFamily: 'Mulish' },
  mobText:
    { padding: 5, color: '#616161', fontFamily: 'Mulish', fontSize: '14px' },
  mobText_XXHDPI:
    { padding: 0, color: '#616161', fontFamily: 'Mulish', fontSize: '14px' },
  mobText_XHDPI:
    { paddingBottom: widthInPercentage(4), color: '#616161', fontFamily: 'Mulish', fontSize: '10px' },
  stepsStyle: { flex: 1, flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' },
  stepsStyle_LDPI: { width: widthInPercentage(1), flexDirection: 'column', marginHorizontal: widthInPercentage(0) },
  stepsStyle_MDPI: { width: widthInPercentage(1), flexDirection: 'column', marginHorizontal: widthInPercentage(0) },
  secondViewStyle: { flex: 3, flexDirection: 'column' },
  secondViewStyle_LDPI: { flex: 8, flexDirection: 'column' },
  secondViewStyle_MDPI: { flex: 8, flexDirection: 'column' },
  secondViewStyle_XXHDPI: { flex: 4, flexDirection: 'column' },
  HomebuttonView: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(-1),
    marginBottom: widthInPercentage(22)
  },
  HomebuttonView_LAPTOP: {
    width: widthInPercentage(50),
    //paddingHorizontal:2,
    position: 'absolute',
    marginTop: widthInPercentage(-1),
    marginBottom: widthInPercentage(20)
  },
  HomebuttonView_LDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(-2),
    marginBottom: widthInPercentage(20)
  },
  HomebuttonView_MDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(-1),
    marginBottom: widthInPercentage(20)
  },
  HomebuttonsViewMob: {
    // width: widthInPercentage(40),
    // //position: 'absolute',
    // marginTop: widthInPercentage(-0.5),
    //marginBottom: widthInPercentage(20),
    marginLeft: widthInPercentage(20),
  },
  HomebuttonsView: {
    width: widthInPercentage(40),
    position: 'absolute',
    marginTop: widthInPercentage(-0.5),
    marginBottom: widthInPercentage(20)
  },
  HomebuttonsView_MDPI: {
    zIndex: 99999999999999,
    //width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(-0.5),
    marginBottom: widthInPercentage(20)
  },
  HomebuttonsView_LDPI: {
    zIndex: 99999999999999,
    width: widthInPercentage(20),
    position: 'absolute',
    marginTop: widthInPercentage(-0.5),
    marginBottom: widthInPercentage(20)
  },
  MainViewTop_LAPTOP: {
    width: '100%', flexDirection: 'row',
  },
  MainViewTop: {
    width: '100%', flexDirection: 'row',
  },
  MainViewTop_XXHDPI: {
    width: '100%', flexDirection: 'row',
  },
  MainViewTop_XXXHDPI: {
    width: '100%', flexDirection: 'row',
  },
  MainViewTop_XHDPI: {
    width: '100%', flexDirection: 'row',
  },
  MainViewTop_LDPI: {
    width: '100%', flexDirection: 'row', paddingTop: widthInPercentage(0)
  },
  MainViewTop_MDPI: {
    width: '100%', flexDirection: 'row', paddingTop: widthInPercentage(2.5)
  },
  HomebuttonViewStyle_LAPTOP: {
    width: widthInPercentage(50),
    position: 'absolute',
    height: widthInPercentage(15),
    marginBottom: widthInPercentage(40)
  },
  HomebuttonViewStyle: {
    width: widthInPercentage(50),
    position: 'absolute',
    height: widthInPercentage(15),
    marginBottom: widthInPercentage(40)
  },
  HomebuttonViewStyle_XXHDPI: {
    width: widthInPercentage(99),
    position: 'absolute',
    height: widthInPercentage(15),
    marginTop: widthInPercentage(-2),
    marginBottom: widthInPercentage(70)
  },
  HomebuttonViewStyle_XHDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    height: widthInPercentage(15),
    marginTop: widthInPercentage(-2),
    marginBottom: widthInPercentage(70)
  },
  HomebuttonViewStyle_LDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(-2),
    height: widthInPercentage(3),
    marginBottom: widthInPercentage(40)
  },
  HomebuttonViewStyle_HDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    height: widthInPercentage(3),
    marginBottom: widthInPercentage(40)
  },
  HomebuttonViewStyle_MDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(-4),
    height: widthInPercentage(3),
    marginBottom: widthInPercentage(40)
  },
  combinedViewMob: {
    marginTop: '15%',
    zIndex: 3,
    height: '20%',
    display: 'flex',
    flexDirection: 'row'
  },
  PayHomeButton:
  {
    width: widthInPercentage(55),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PayHomeButton_LDPI:
  {
    width: widthInPercentage(55),
    // position: 'absolute',
    // marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButton_MDPI:
  {
    width: widthInPercentage(55),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PayHomeButton_HDPI:
  {
    width: widthInPercentage(15),
    position: 'none',
    marginTop: 0,
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: 0
  },
  PaymentHomeButton:
  {
    width: widthInPercentage(55),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10)
  },
  PaymentHomeButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(3),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30)
  },
  PaymentHomeButton_LDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(2),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(25)
  },
  PaymentHomeButton_MDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(2),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(25)
  },
  PaymentHomeButton_HDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(2),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(25)
  },
  PayBackButton:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PayBackButton_LDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10),
    marginLeft: '19%'
  },
  PayBackButton_MDPI:
  {
    //width: widthInPercentage(50),
    position: 'none',
    marginTop: widthInPercentage(0),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(10),
    //marginLeft: widthInPercentage(16)
  },
  PayBackButton_HDPI:
  {
    width: widthInPercentage(50),
    // position: 'absolute',
    // marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PaymentBackButton:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PaymentBackButton_LAPTOP:
  {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(8),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(16)
  },
  PaymentBackButton_LDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(12),
    height: widthInPercentage(15),
    paddingBottom: '2%',
    marginBottom: widthInPercentage(20),
    paddingTop: '5%',
  },
  PaymentBackButton_MDPI:
  {
    width: widthInPercentage(55),
    // position: 'absolute',
    // marginTop: widthInPercentage(12),
    height: widthInPercentage(15),
    paddingVertical: '2%',
    marginBottom: widthInPercentage(30),
    marginLeft: widthInPercentage(16),
    display: 'flex',
    flexDirection: 'row'
  },
  PaymentBackButton_HDPI:
  {
    width: widthInPercentage(30),
    position: 'absolute',
    marginTop: widthInPercentage(12),
    height: widthInPercentage(15),
    paddingBottom: '2%',
    marginBottom: widthInPercentage(20),
    paddingTop: '5%',
  },
  threeBoxView: { flexDirection: 'column', flex: 1, padding: widthInPercentage(1) },
  threeBoxView_XXHDPI: { flexDirection: 'column', flex: 1, padding: widthInPercentage(2) },
  threeBoxView_LAPTOP: { flexDirection: 'column', flex: 1, padding: widthInPercentage(1) },
  UploadedFileText: {
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 600,
    fontFamily: 'Mulish',
    padding: 5,
    // marginBottom: '0.5%',
    marginTop: '0.5%',
    //textAlign: 'center'
  },
  UploadedFileText_LAPTOP: {
    fontSize: 14,
  },
  UploadedFileText_LDPI: {
    fontSize: 12,
  },
  UploadedFileText_HDPI: {
    fontSize: 14,
  },
  UploadedFileText_MDPI: {
    fontSize: 14,
  },
  UploadedFileText_XHDPI: {
    fontSize: 14,
  },
  row: {
    flexDirection: 'row'
  },
  containerTableScreen: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    //maxHeight: 400,
    maxHeight: 300,
    overflow: 'auto',
    //width: 991,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    justifyContent: 'initial',
    // border: "0.5px solid red"
  },
  containerTableScreenECS: {
    flex: 1,
    paddingRight: 10,
    width: 800,
    alignItems: 'center',
    fontSize: 12,
    justifyContent: 'initial'
  },
  containerTableScreenATM: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 234,
    overflowX: 'auto',
    overflowY: 'auto',
    fontSize: 30,
    marginLeft: 0,
  },
  containerTableScreenATMECS: {
    flex: 1,
    paddingRight: 10,
    paddingBottom: '1%',
    maxHeight: 234,
    overflowX: 'auto',
    overflowY: 'auto',
    fontSize: 30,
    marginLeft: 0,
  },
  containerTableScreenECS_MDPI: {
    flex: 1,
    paddingRight: 10,
    maxHeight: '100%',
    overflowX: 'auto',
    overflowY: 'auto',
    width: 280,
    alignItems: 'center',
    justifyContent: 'initial',
    fontSize: 30,
    marginLeft: 10,
    marginBottom: '10%'
  },
  containerTableScreen_LDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: "100%",
    alignItems: 'center',
    justifyContent: 'initial',
    // fontSize: 30,
    marginLeft: 0
    // border: "0.5px solid red"
  },
  containerTableScreen_MDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    //paddingTop:95,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: "100%",
    paddingLeft: 0,
    alignItems: 'center',
    // justifyContent: 'center',
    // fontSize: 30,
    marginLeft: 0,
    justifyContent: 'initial'
    // border: "0.5px solid red"
  },
  containerTableScreen_HDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: "100%",
    paddingLeft: 4,
    alignItems: 'center',
    //justifyContent: 'center',
    // fontSize: 30,
    marginLeft: 0,
    justifyContent: 'initial',
    // border: "0.5px solid red"
  },
  containerTableScreen_XXHDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    // paddingRight: 560,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: "100%",
    justifyContent: 'start',
    alignItems: 'baseline',
    // fontSize: 30,
    marginLeft: 0,
    // border: "0.5px solid red"
  },
  containerTableScreenEMI: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 350,
    overflow: 'auto',
    width: '100%',
    alignItems: 'center',
    fontSize: 12,
    justifyContent: 'initial'
  },
  containerTableScreenEMI_LDPI: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'initial',
    fontSize: 30,
  },
  containerTableScreenEMI_MDPI: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
    paddingLeft: 4,
    alignItems: 'center',
    fontSize: 30,
    justifyContent: 'initial'
  },
  containerTableScreenEMI_HDPI: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
    paddingLeft: 4,
    alignItems: 'center',
    fontSize: 30,
    justifyContent: 'initial',
  },
  containerTableScreenEMI_XXHDPI: {
    flex: 1,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '100%',
    justifyContent: 'start',
    alignItems: 'baseline',
    fontSize: 30,
    marginLeft: 0,
  },
  containerTable: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 300,
    overflow: 'auto',
    width: 793,
    alignItems: 'center',
    fontSize: 30,
    justifyContent: 'initial'
  },
  containerTableServices: {
    flex: 1,
    overflow: 'auto',
    width: 965,
    alignItems: 'center',
    fontSize: 30,
    justifyContent: 'initial'
  },
  containerTableOther: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 400,
    overflow: 'auto',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 30
  },
  containerTableATM: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 234,
    overflowX: 'auto',
    overflowY: 'auto',
    width: 600,
    // alignItems: 'center',
    // justifyContent: 'center',
    fontSize: 30,
    marginLeft: 10,
    //paddingTop: '56%'
  },
  containerTable_LDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '90%',
    alignItems: 'center',
    justifyContent: 'initial',
    fontSize: 30,
    marginLeft: 10
    // border: "0.5px solid red"
  },
  containerTable_MDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 1,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '90%',
    alignItems: 'center',
    // justifyContent: 'center',
    fontSize: 30,
    marginLeft: 10,
    justifyContent: 'initial'
    // border: "0.5px solid red"
  },
  containerTable_HDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 83,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '90%',
    alignItems: 'center',
    //justifyContent: 'center',
    fontSize: 30,
    marginLeft: 10,
    justifyContent: 'initial',
    // border: "0.5px solid red"
  },
  containerTable_XXHDPI: {
    flex: 1,
    // padding: 5,
    //paddingTop: 25,
    paddingRight: 10,
    maxHeight: 400,
    overflowX: 'auto',
    overflowY: 'auto',
    width: '90%',
    // alignItems: 'center',
    // justifyContent: 'center',
    fontSize: 30,
    marginLeft: 10
    // border: "0.5px solid red"
  },
  ECSPreviewScreenText: {
    justifyContent: 'center',
    textAlign: 'end',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingRight: '2%',
    paddingBottom: '2%'
  },
  ECSPreviewScreenText_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingLeft: '8%',
    paddingBottom: '2%'
  },
  ECSPreviewScreenText_XXHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingLeft: '8%',
    paddingBottom: '2%'
  },
  // ECSPreviewScreenText_ATM:{
  //   justifyContent: 'center',
  //   alignItems: 'center',
  //   textAlign: 'center',
  //   fontSize: 16,
  //   fontFamily: 'Roboto',
  //   fontWeight:'bold',
  //   paddingTop:'1.5%',
  //   paddingLeft:'8%',
  //   paddingBottom:'2%'
  // },
  ConvertEMIPreviewScreenText: {
    justifyContent: 'center',
    //alignItems: 'center',
    textAlign: 'end',
    marginRight: '0%',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingRight: '0%',
    paddingBottom: '2%'
  },
  ConvertEMIPreviewScreenText_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    marginLeft: window.innerWidth > 360 && window.innerWidth > 390 ? '5%' : '-1%',
    //paddingLeft: '7%',
    paddingBottom: '2%'
  },
  ConvertEMIPreviewScreenText_XXHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingLeft: '8%',
    paddingBottom: '2%'
  },
  ConvertEMIPreviewScreenText_ATM: {
    justifyContent: 'center',
    //alignItems: 'center',
    textAlign: 'end',
    marginRight: '0%',
    fontSize: 16,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    paddingTop: '1.5%',
    paddingRight: '0%',
    paddingBottom: '2%'
  },
  btn: {
    width: 98,
    height: 25,
    backgroundColor: '#e77817',
    borderRadius: 3,
    justifyContent: 'center',
    paddingTop: 6,
    paddingBottom: 6
  },
  btnRes: {
    width: 74,
    height: 21,
    borderRadius: 3,
    justifyContent: 'center',
    paddingVertical: 2,
    marginVertical: 8,
    fontWeight: 'bold',
    color: 'black'
  },
  // btnResLdpi: {
  //   width: 64,
  //   height: 15,
  //   backgroundColor: '#e77817',
  //   borderRadius: 3,
  //   justifyContent: 'center',
  //   paddingVertical: 2
  // },
  btnText: {
    textAlign: 'center',
    color: 'black',
    justifyContent: 'center',
  },
  btnTextRes: {
    textAlign: 'center',
    color: 'black',
    justifyContent: 'center',
  },
  textTable: {
    display: 'flex',
    fontSize: 15,
    // alignItems: 'center',
    padding: widthInPercentage(5),
    // justifyContent: 'center',
    // textAlign: 'center',
    //height: 35,
    //flexDirection: 'row'
  },
  textTableSR: {
    fontSize: 15,
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
    //height: 35,
    //flexDirection: 'row'
  },
  textTablescreen: {
    fontSize: 14,
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
    //height: 35,
    //flexDirection: 'row'
  },
  textTableother: {
    fontSize: 15,
    alignItems: 'center',
    padding: 5,
    justifyContent: 'center',
    textAlign: 'left',
  },
  textTable_LDPI: {
    fontSize: 10,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },
  textTable_MDPI: {
    fontSize: 15,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },
  textTable_HDPI: {
    fontSize: 15,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },

  textTableRes: {
    fontSize: 15,
    alignItems: 'center',
    //paddingHorizontal: 2,
    padding: '1%',
    justifyContent: 'center',
    textAlign: 'center'
  },
  textTableHead: {
    fontSize: 17,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 2,
    paddingVertical: 4,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  textTableHeadTablescreen: {
    fontSize: 15,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 2,
    paddingVertical: 4,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  textTableHeadRes: {
    fontSize: 15,
    alignItems: 'center',
    //paddingHorizontal: 2,
    width: 90,
    padding: '1%',
    justifyContent: 'center',
    textAlign: 'center',
    fontWeight: 'bold'
  },
  textTableHead_MDPI: {
    fontSize: 15,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },
  textTableHead_HDPI: {
    fontSize: 15,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },
  textTableHead_XXHDPI: {
    fontSize: 15,
    alignItems: 'center',
    paddingHorizontal: 2,
    justifyContent: 'center',
    textAlign: 'center'
  },
  dataWrapper: { marginTop: -1 },
  // textTable: {
  //   fontSize: 20,
  //   alignItems: 'center',
  //   paddingHorizontal: 2,
  //   justifyContent: 'center',
  //   textAlign: 'center'
  // },
  // textTableHead: {
  //   fontSize: 20,
  //   alignItems: 'center',
  //   justifyContent: 'center',
  //   paddingHorizontal: 2,
  //   textAlign: 'center'
  // },
  Upperviewpayamt: {
    flex: 1
  },
  Upperviewpayamt_MDPI: {
    flex: 1
  },
  Upperviewpayamt_LDPI: {
    flex: 1
  },
  Lowerviewpayamt: {
    flex: 1
  },
  Lowerviewpayamt_HDPI: {
    flex: 1,
    marginRight: '55%'
  },
  Lowerviewpayamt_MDPI: {
    flex: 1,
    marginRight: '62%'
  },
  Lowerviewpayamt_LDPI: {
    flex: 1,
    marginRight: '66%'
  },
  Newcombviewpayamt: {
    flexDirection: 'row',
    width: '100%',
    marginTop: '13%',
    marginHorizontal: '5%'
  },
  Newcombviewpayamts: {
    flexDirection: 'row',
    width: '100%',
    marginTop: '30%',
    marginHorizontal: '5%'
  },
  Newcombviewpayamts_HDPI: {
    flexDirection: 'row',
    width: '94%',
    marginTop: '30%',
    marginHorizontal: '5%'
  },
  Newcombviewpayamts_MDPI: {
    flexDirection: 'row',
    width: '94%',
    marginTop: '30%',
    marginHorizontal: '5%'
  },
  transactionSuccessHomeView: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(5),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    zIndex: 3,
    marginBottom: widthInPercentage(20)
  },
  transactionSuccessHomeView_MDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(10),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    zIndex: 3,
    marginBottom: widthInPercentage(20)
  },
  transactionSuccessHomeView_LDPI: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(13),
    height: widthInPercentage(10),
    paddingVertical: '2%',
    zIndex: 3,
    marginBottom: widthInPercentage(20)
  },
  approveView: {
    marginTop: '1%',
    width: widthInPercentage(100),
    alignItems: 'center',
    paddingHorizontal: '5%',
    paddingBottom: widthInPercentage(10),
  },
  approveView_HDPI: {
    marginTop: '1%',
    alignItems: 'center',
    //marginHorizontal: widthInPercentage(5)
    //paddingHorizontal: '12%'
  }, approveView_LDPI: {
    marginTop: '1%',
    alignItems: 'center',
    //paddingHorizontal: '2%'
  }, approveView_MDPI: {
    marginTop: '1%',
    alignItems: 'center',
    //paddingHorizontal: '1%',
    //marginHorizontal: widthInPercentage(1)
  },

  approveViewsub: {
    flex: 1,
    alignContent: 'center',
    alignItems: 'center'
  },
  approveViewsub_HDPI: {
    flex: 1,
    alignContent: 'center',
    alignItems: 'center'
  }, approveViewsub_LDPI: {
    flex: 1,
    alignContent: 'center',
    alignItems: 'center'
  }, approveViewsub_MDPI: {
    flex: 1,
    alignContent: 'center',
    alignItems: 'center'
  },
  approveInnerView: {
    flexDirection: 'row',
    flex: 1,
    width: widthInPercentage(100),
    justifyContent: 'center'
  },
  approveInnerView_LDPI: {
    flexDirection: 'row',
    flex: 1,
    width: widthInPercentage(80),
    justifyContent: 'center'
  },
  approveInnerView_MDPI: {
    flexDirection: 'row',
    flex: 1,
    width: widthInPercentage(80),
    justifyContent: 'center'
  },
  approveInnerView_HDPI: {
    flexDirection: 'row',
    flex: 1,
    width: widthInPercentage(80),
    justifyContent: 'center'
  },
  textHeadingupdatedscreen_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 30,
    lineHeight: 28,
  },
  confirmCustomerMainView: {
    marginHorizontal: widthInPercentage(6),
    marginTop: widthInPercentage(5),
    backgroundColor: '#ffffff',
  },
  confirmCustomerMainView_LDPI: {
    marginHorizontal: widthInPercentage(1),
    marginTop: widthInPercentage(35),
  },
  confirmCustomerMainView_MDPI: {
    marginHorizontal: widthInPercentage(1),
    marginTop: widthInPercentage(35),
  },
  confirmCustomerMainView_HDPI: {
    marginHorizontal: widthInPercentage(1),
    marginTop: widthInPercentage(35),
  },
  confirmCustomerMainView_XHDPI: {
    marginHorizontal: widthInPercentage(1),
    marginTop: widthInPercentage(35),
  },
  approveText: { marginHorizontal: widthInPercentage(4), marginTop: widthInPercentage(2) },
  usertxt: {
    fontFamily: 'Mulish',
    fontSize: 16,
    fontWeight: '500'
  },
  usertxt_XXXHDPI: { fontSize: 15, marginLeft: 0 },
  usertxt_XXHDPI: { fontSize: 14, marginLeft: 0 },
  usertxt_XHDPI: { fontSize: 14, marginLeft: 0 },
  usertxt_HDPI: { fontSize: 14, marginLeft: 0 },
  usertxt_MDPI: { fontSize: 14, marginLeft: 0 },
  usertxt_LDPI: { fontSize: 14, marginLeft: 0 },
  approveText_LDPI: { marginHorizontal: widthInPercentage(0), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  approveText_MDPI: { marginHorizontal: widthInPercentage(0), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  approveText_HDPI: { marginHorizontal: widthInPercentage(8), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  sendtext: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 24,
    fontWeight: '200',
    fontFamily: 'Mulish',
    marginTop: '2%',
    color: '#222222',
    lineHeight: 39,
    paddingHorizontal: '1%'
  },
  sendtext_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 20,
    fontWeight: '200',
    color: '#222222',
    fontSize: 30,
    lineHeight: 28,
  },
  sendtext_MDPI: {
    fontSize: 20,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? '21%' : 34,
    lineHeight: 28,
  },
  sendtext_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 18,
    fontWeight: '200',
    color: '#222222',
    lineHeight: 28,
    marginTop: '25%'
  },
  subheadertxt: {
    fontFamily: 'Mulish',
    fontSize: 18,
    fontWeight: 'bold',

    marginLeft: '1%'
  },
  subheadertxt_XXXHDPI: { fontSize: 15, marginLeft: 0 },
  subheadertxt_XXHDPI: { fontSize: 14, marginLeft: 0 },
  subheadertxt_XHDPI: { fontSize: 14, marginLeft: 0 },
  subheadertxt_HDPI: { fontSize: 14, marginLeft: 0 },
  subheadertxt_MDPI: { fontSize: 14, marginLeft: 0 },
  subheadertxt_LDPI: { fontSize: 14, marginLeft: 0 },
  textTableHeadSum: {
    fontSize: 23,
    alignItems: 'center',
    justifyContent: 'center',
    paddingHorizontal: 2,
    paddingVertical: 4,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  textTableSum: {
    fontSize: 23,
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
  },
  textTableSum_Mobile: {
    fontSize: 23,
    // alignItems: 'center',
    padding: '2%',
    // justifyContent: 'center',
    // textAlign: 'center',
  },
  textTableSumBold: {
    fontSize: 23,
    fontWeight: 'bold',
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
  },
  textTableSumBold_Mobile: {
    fontSize: 23,
    fontWeight: 'bold',
    alignItems: 'center',
    padding: 2,
    justifyContent: 'center',
    textAlign: 'center',
  },
  textHeadingUpdatedpage: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    //fontSize: 32,
    fontWeight: '600',
    fontFamily: 'Mulish',
    // marginTop: '1%',
    color: '#222222',
    lineHeight: 28,
    lineHeight: 54,
    paddingHorizontal: '1%'
  },
  textHeadingUpdatedpage_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 30,
  },
  textHeadingUpdatedpage_MDPI: {
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? 24 : 34,
    lineHeight: 35
  },
  textHeadingUpdatedpage_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 26,
    fontWeight: '600',
    color: '#222222',
  },
  textHeadingSorry: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 32,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: widthInPercentage(0),
    color: '#222222',
    lineHeight: 28,
    paddingHorizontal: '1%'
  },
  textHeadingSorry_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    fontSize: 30,
  },
  textHeadingSorry_MDPI: {
    fontSize: 30,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? 24 : 34,
    lineHeight: 35
  },
  textHeadingSorry_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 26,
    fontWeight: '600',
    color: '#222222',
  },
  textTableHeadSumFD: {
    fontSize: 15,
    paddingHorizontal: 10,
    paddingVertical: 15,
    //textAlign: 'center',
    fontWeight: 'bold',
  },
  textTableSumFD: {
    fontSize: 14,
    paddingVertical: 4,
    textAlign: 'center',
  },
  containerTableOtherErrorPage: {
    flex: 1,
    paddingRight: 10,
    maxHeight: 400,
    overflow: 'auto',
    width: 544,
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 20
  },
   DOBFileSizeNote: {
    fontSize: 11,
    fontFamily: 'Mulish',
    maxWidth: 547,
    color: 'black'
  },
  DOBFileSizeNote_LDPI: {
    fontSize: 14,
    fontFamily: 'Mulish',
    maxWidth: 310,
    color: 'black'
  },
  DOBFileSizeNote_MDPI: {
    fontSize: 14,
    fontFamily: 'Mulish',
    maxWidth: 310,
    color: 'black'
  },
  DOBFileSizeNote_HDPI: {
    fontSize: 14,
    fontFamily: 'Mulish',
    maxWidth: 310,
    color: 'black'
  },
  DOBFileSizeNote_XHDPI: {
    fontSize: 14,
    fontFamily: 'Mulish',
    maxWidth: 310,
    color: 'black'
  },
  declareTxtupdate:
    { fontSize: 14, justifyContent: 'center' },
  declareTxtupdate_LAPTOP: { fontSize: 14, justifyContent: 'center' },
  declareTxtupdate_XHDPI: { fontSize: 10, justifyContent: 'center' },
  declareTxtupdate_LDPI: { fontSize: 10, justifyContent: 'center' },
  declareTxtupdate_MDPI: { fontSize: 10, justifyContent: 'center' },
  declareTxtupdate_HDPI: { fontSize: 10, justifyContent: 'center' },
  cardekhoContentAtm: {
    minHeight: 324,
    width: '94%',
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    alignItems: 'center',
    paddingBottom: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowOpacity: 0.37,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 8,
    marginLeft: 22,
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#ffff'
  },
  cardekhoContentOtherScreens: {
    minHeight: 300,
    width: '85%',
    display: 'flex',
    flex: 1,
    justifyContent: 'space-around',
    flexDirection: 'column',
    alignItems: 'center',
    //paddingBottom: 6,
    shadowColor: '#000',
    shadowOffset: {
      width: 2,
      height: 2
    },
    shadowOpacity: 0.37,
    shadowRadius: 4.65,
    elevation: 6,
    borderRadius: 8,
    marginLeft: '10%',
    marginTop: 10,
    marginBottom: 10,
    backgroundColor: '#ffff'
  },
  cardekhoContentOtherScreens_XXHDPI: {
    marginLeft: 45
  },
  cardekhoContentOtherScreens_HDPI: {
    marginTop: '50%',
  },
  cardekhoContentOtherScreens_MDPI: {
    marginTop: '50%',
  },
  cardekhoContentOtherScreens_LDPI: {
    marginTop: '50%',
  },
  cardekhoScreenNormal: {
    display: 'flex',
    flexDirection: 'column',
    width: '94%'
  },
  cardekhoScreenNormal_XXXHDPI: { display: 'flex', flexDirection: 'row' },
  cardekhoScreenNormal_XXHDPI: { display: 'flex', flexDirection: 'row' },
  cardekhoScreenNormal_XHDPI: { display: 'flex', flexDirection: 'column' },
  cardekhoScreenNormal_HDPI: { display: 'flex', flexDirection: 'column' },
  cardekhoScreenNormal_MDPI: { display: 'flex', flexDirection: 'column' },
  cardekhoScreenNormal_LDPI: { display: 'flex', flexDirection: 'column' },
  carDekhoOkbuttonMainView: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingTop: 20,
    paddingHorizontal: 20
  },
  carDekhoOkbuttonMainView_LDPI: { paddingBottom: 20 },
  carDekhoOkbuttonMainView_MDPI: { paddingBottom: 20 },
  carDekhoOkbuttonMainView_HDPI: { paddingBottom: 0, paddingTop: 9 },
  carDekhoOkbuttonMainView_XHDPI: { paddingBottom: 0, paddingTop: 9 },
  carDekhoOkbutton: {
    backgroundColor: '#e77817',
    // backgroundImage:
    //   Platform.OS === "web" ? "linear-gradient(#00008B,#101d6c)" : null,
    marginBottom: 10,
    //marginRight: 55,
    flexDirection: 'row',
    borderRadius: 10,
    textAlign: 'center',
    width: 100,
    paddingVertical: '1%',
    color: 'black',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 3
    },
    shadowOpacity: 0.27,
    shadowRadius: 4.65,
    elevation: 6,
    justifyContent: 'center'
  },
  carDekhoOkbutton_LDPI: { marginBottom: 0, paddingTop: 10, paddingBottom: 10 },
  carDekhoOkbutton_MDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    width: 90
  },
  carDekhoOkbutton_HDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    marginRight: 24
  },
  carDekhoOkbutton_XHDPI: {
    marginBottom: 0,
    paddingTop: 5,
    paddingBottom: 5,
    marginRight: 18,
    width: 80
  },
  carDekholastscreenheading: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // right: '0%'
  },
  carDekholastscreenheading_LAPTOP: {
    display: 'flex',
    flex: 2,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    // right: '0%'
  },
  carDekholastscreenheading_LDPI: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: '7%'
  },
  carDekholastscreenheading_MDPI: { flexDirection: 'row', marginLeft: 0 },
  carDekholastscreenheading_HDPI: { flexDirection: 'row', marginLeft: '5%' },
  carDekholastscreenheading_XHDPI: {
    flexDirection: 'row',
    //marginLeft: '40%'
  },
  carDekholastscreenheading_XXHDPI: { flexDirection: 'row', },
  carDekholastscreenheading_XXXHDPI: { flexDirection: 'row', },

  carDekholastscreenheadingtxt: {
    fontFamily: 'Mulish',
    fontSize: 28,
    fontWeight: '500',
    marginLeft: 0
  },
  carDekholastscreenheadingtxt_XXXHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingtxt_XXHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingtxt_XHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingtxt_HDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingtxt_MDPI: { fontSize: 17, marginLeft: 0 },
  carDekholastscreenheadingtxt_LDPI: { fontSize: 16, marginLeft: 0 },


  carDekholastscreenheadingsubtxt: {
    fontFamily: 'Mulish',
    fontSize: 24,
    fontWeight: '400',
    marginLeft: 0
  },
  carDekholastscreenheadingsubtxt_XXXHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingsubtxt_XXHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingsubtxt_XHDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingsubtxt_HDPI: { fontSize: 18, marginLeft: 0 },
  carDekholastscreenheadingsubtxt_MDPI: { fontSize: 17, marginLeft: 0 },
  carDekholastscreenheadingsubtxt_LDPI: { fontSize: 16, marginLeft: 0 },
  carDekholastscreenSplit: {
    flexDirection: 'row',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column'
  },
  carDekholastscreenSplit_XXXHDPI: { flexDirection: 'column', alignItems: 'center' },
  carDekholastscreenSplit_XXHDPI: { flexDirection: 'column', alignItems: 'center' },
  carDekholastscreenSplit_XHDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center'
  },
  carDekholastscreenSplit_HDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '4%'
  },
  carDekholastscreenSplit_MDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '13%'
  },
  carDekholastscreenSplit_LDPI: {
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '4%'
  },
  carDekhoOkbuttontxt: {
    color: '#fff',
    fontSize: 20,
    fontWeight: 'normal',
    paddingVertical: '10%',
    paddingHorizontal: '10%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish'
  },
  carDekhoOkbuttontxt_XXHDPI: { fontSize: 20 },
  carDekhoOkbuttontxt_XHDPI: { fontSize: 16 },
  carDekhoOkbuttontxt_HDPI: { fontSize: 16 },
  carDekhoOkbuttontxt_MDPI: { fontSize: 16 },
  carDekhoOkbuttontxt_LDPI: { fontSize: 14 },
  Detailsnexttext: {
    fontFamily: 'Mulish',
    fontSize: 11,
    textAlign: 'justify'
  },
  Detailsnexttextmachine: {
    fontFamily: 'Mulish',
    fontSize: 9,
    textAlign: 'justify'
  },
  Detailsnexttext_LDPI: { fontSize: 9, textAlign: 'justify' },
  Detailsnexttext_MDPI: { fontSize: 9, textAlign: 'justify' },
  Detailsnexttext_HDPI: { fontSize: 9, textAlign: 'justify' },
  Detailsnexttext_XHDPI: { fontSize: 9, textAlign: 'justify' },
  Detailsnexttext_XXHDPI: { fontSize: 9, textAlign: 'justify' },
  NotesRow: { display: 'flex', flexDirection: 'row', width: '100%' },
  NotesRow_LDPI: { width: '100%' },
  NotesRow_MDPI: { width: '100%' },
  NotesRow_HDPI: { width: '100%' },
  NotesRow_XHDPI: { width: '100%' },
  NotesRow_XXHDPI: { width: '100%' },
  declareTxtupdate_LAPTOP: { fontSize: 11 },
  declareTxtupdate_XHDPI: { fontSize: 10 },
  declareTxtupdate_LDPI: { fontSize: 10 },
  declareTxtupdate_MDPI: { fontSize: 10 },
  declareTxtupdate_HDPI: { fontSize: 10 },
  textMessageSubHeadingUpdatedpage: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 20,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: '2%',
    color: '#222222',
    lineHeight: 28,
    paddingHorizontal: '2%'
  },
  textMessageSubHeadingUpdatedpage_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: '600',
    color: '#222222',
    fontSize: 20,
  },
  textMessageSubHeadingUpdatedpage_MDPI: {
    fontSize: 15,
    fontWeight: '600',
    color: '#222222',
    marginTop: Platform.OS === 'web' ? 24 : 34,
    lineHeight: 35
  },
  textMessageSubHeadingUpdatedpage_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '600',
    color: '#222222',
  },
  textMessageSubHeadingUpdatedpageMAB: {
    //justifyContent: 'center',
    // alignItems: 'center',
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '600',
    fontFamily: 'Mulish',
    marginTop: '0%',
    color: '#222222',
    //lineHeight: 28,
    paddingHorizontal: '5%'
  },
  textMessageSubHeadingUpdatedpageMAB_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: '600',
    color: '#222222',
    fontSize: 20,
  },
  textMessageSubHeadingUpdatedpageMAB_MDPI: {
    fontSize: 15,
    justifyContent: 'center',
    alignItems: 'center',
    width: '93%',
    fontWeight: '600',
    textAlign: 'left',
    color: '#222222',
    marginLeft: '4%',
    marginTop: Platform.OS === 'web' ? 24 : 34,
  },
  textMessageSubHeadingUpdatedpageMAB_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '600',
    color: '#222222',
    marginLeft: '4%',
    width: '92%',
  },
  textMessageTransferAccount: {
    //justifyContent: 'center',
    // alignItems: 'center',
    textAlign: 'left',
    fontFamily: 'Mulish',
    paddingLeft: '17%',
    fontSize: 14,
    fontWeight: '600',
    fontFamily: 'Mulish',
    // marginTop: '-7%',
    color: '#222222',
    //lineHeight: 28,
    paddingHorizontal: '10%'
  },
  textMessageTransferAccount_XHDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontFamily: 'Mulish',
    fontWeight: '600',
    color: '#222222',
    fontSize: 20,
    marginTop: '1%'
  },
  textMessageTransferAccount_XXHDPI: {
    //justifyContent: 'center',
    //alignItems: 'center',
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontWeight: '600',
    color: '#222222',
    fontSize: 15,
    marginTop: '1%'
  },
  textMessageTransferAccount_MDPI: {
    fontSize: 15,
    // justifyContent: 'center',
    // alignItems: 'center',
    width: '93%',
    fontWeight: '600',
    textAlign: 'left',
    color: '#222222',
    marginLeft: '4%',
    marginTop: Platform.OS === 'web' ? 24 : 34,
  },
  textMessageTransferAccount_LDPI: {
    //justifyContent: 'center',
    // alignItems: 'center',
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 14,
    fontWeight: '600',
    color: '#222222',
    marginLeft: '4%',
    width: '92%',
    marginTop: '0%'
  },
  resendBtn: {
    width: '20%',
    height: 50,
    justifyContent: 'center',
    borderRadius: 1,
    backgroundColor: '#e77817',
    padding: 10,
    borderRadius: 5,
    marginTop: 30
  },
  resendBtn_MDPI: {
    marginTop: 15
  },
  resendBtn_LDPI: {
    marginTop: 15
  },
  resendBtn_HDPI: {
    marginTop: 15
  },
  resendBtn_XHDPI: {
    marginTop: 15
  },
  modalHeaderStyle: {
    borderRadius: 5,
    flexDirection: 'column',
    backgroundColor: 'white',
    paddingVertical: widthInPercentage(2),
    justifyContent: 'center',
    alignItems: 'start',
    alignContent: 'center',
    margin: 'auto',
    width:'fit-content'
  },
  modalHeaderStyle_LDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeaderStyle_HDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeaderStyle_MDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeaderStyle_XHDPI: { marginHorizontal: 'auto', width: widthInPercentage(60) },
  modalHeaderStyle_XXHDPI: {
    marginHorizontal: 'auto',
    width: widthInPercentage(100),
  },
  modalHeader: { borderRadius: 5, flexDirection: 'column', backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: 'auto', width: 'fit-content' },
  modalHeader_LAPTOP: { flexDirection: 'column', backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: 'auto', width: widthInPercentage(80) },
  modalHeader_XXXHDPI: { marginHorizontal: 'auto', width: widthInPercentage(60) },
  modalHeader_XXHDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeader_LDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeader_HDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeader_MDPI: { marginHorizontal: 'auto', width: widthInPercentage(100) },
  modalHeader_XHDPI: { marginHorizontal: 'auto', width: widthInPercentage(60) },
  notesHeaderText: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontWeight: '500',
    fontSize: 18,
    //color: '#894302',
    alignItems: 'center',
    justifyContent: 'center',
    //color: '#101d6c',
    //marginLeft:widthInPercentage(56)
  },
  notesText: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 12,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  notesText_LDPI: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  notesText_MDPI: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  notesText_HDPI: {
    textAlign: 'left',
    fontFamily: 'Mulish',
    fontSize: 10,
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  okButton: {
    flex: 1,
    paddingHorizontal: 20,
    paddingVertical: 8,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    marginTop: 15,
  },
  okButton_MDPI: {
    marginHorizontal: '0%',
    flex: 2,
    paddingHorizontal: 20,
    paddingVertical: 8,
  },
  okButton_LDPI: {
    marginHorizontal: '0%',
    flex: 2,
    paddingHorizontal: 20,
    paddingVertical: 8,
  },
  btnTextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 18,
    fontFamily: 'Mulish',
    color: 'white'
  },
  btnTextStyle_LDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Mulish',
    color: 'white'
  },
  btnTextStyle_MDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Mulish',
    color: 'white'
  },
  btnTextStyle_HDPI: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Mulish',
    color: 'white'
  },
  modalStyle: { width: widthInPercentage(50), margin: 'auto' },
  modalStyle_LAPTOP: { width: widthInPercentage(50), margin: 'auto' },
  ModalATMStyle: { width: widthInPercentage(35), margin: 'auto' },
  modalStyle_XHDPI: { width: widthInPercentage(70), margin: 'auto' },
  modalStyle_XXHDPI: { width: widthInPercentage(47), margin: 'auto' },
  modalStyle_XXXHDPI: { width: widthInPercentage(45), margin: 'auto' },
  modalStyle_LDPI: { width: widthInPercentage(94), margin: 'auto' },
  modalStyle_MDPI: { width: widthInPercentage(80), margin: 'auto' },
  // model style
  modalView: { flexDirection: 'column', borderRadius: 10, backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(25), },
  modalView_LAPTOP: { flexDirection: 'column', borderRadius: 10, backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(33), },
  modalView_XXXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },
  modalView_XXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(65) },
  modalView_LDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_HDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_MDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalView_XHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },

  modalPopView: { display:'flex',flexDirection: 'column', borderRadius: 10, backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(25), },
  modalPopView_LAPTOP: { flexDirection: 'column', borderRadius: 10, backgroundColor: 'white', paddingVertical: widthInPercentage(2), justifyContent: 'center', alignItems: 'center', alignContent: 'center', marginHorizontal: widthInPercentage(25), },
  modalPopView_XXXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },
  modalPopView_XXHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(65) },
  modalPopView_LDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalPopView_HDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalPopView_MDPI: { marginHorizontal: widthInPercentage(1), borderRadius: 10, width: widthInPercentage(100) },
  modalPopView_XHDPI: { marginHorizontal: widthInPercentage(10), borderRadius: 10, width: widthInPercentage(60) },

  declarText: { fontFamily: 'Mulish', fontSize: 16, justifyContent: 'center', paddingVertical: 2, paddingLeft: 10 },
  declarText_LAPTOP: { fontSize: 16, justifyContent: 'center' },
  declarText_XHDPI: { fontSize: 13, justifyContent: 'center' },
  declarText_LDPI: { fontSize: 13, justifyContent: 'center' },
  declarText_MDPI: { fontSize: 13, justifyContent: 'center' },
  declarText_HDPI: { fontSize: 13, justifyContent: 'center' },
  agreeButton: {
    flex: 1,
    padding: 10,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 5,
    marginHorizontal: '5%'
  },
  agreeButton_MDPI: {
    marginHorizontal: '0%',
    flex: 2,
    padding: 5,
  },
  agreeButton_LDPI: {
    marginHorizontal: '0%',
    flex: 2,
    padding: 5,
  },
  textStyleModal: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 14,
    fontFamily: 'Mulish',
    color: 'white',
    fontWeight: 'bold'
  },
  //removing inline styles
  //update screen (update.js)
  homeButtonSection: {
    width: widthInPercentage(50),
    position: "absolute",
    marginTop: -10,
    height: widthInPercentage(15),
    paddingVertical: "3%",
    marginBottom: widthInPercentage(20),
  },
  checkBoxView: {
    flexDirection: "row"
  },
  checkBoxView_LDPI: {
    flexDirection: "column"
  },
  checkBoxView_MDPI: {
    flexDirection: "column"
  },
  checkBoxView_HDPI: {
    flexDirection: "column"
  },
  checkBoxSection1: {
    zIndex: -1,
    padding: "2%",
    width: "80%"
  },
  updateLeftSection: {
    flex: 2,
    zIndex: -9999999999
  },
  updateSectionImageView: {
    flex: 2,
    alignItems: "center",
    zIndex: -1
  },
  deviceUpdateLeftView: {
    zIndex: -9
  },
  deviceUpdateSection: {
    flex: 1,
    alignItems: "center",
    zIndex: -1
  },
  updateSectionView: {
    flex: 1,
    paddingTop: "1%"
  },
  //preview screen (updateData.js)
  previewView: {
    justifyContent: "center",
    alignItems: "center",
    marginBottom: "30%",
    marginTop: "10%",
    flex: 2,
  },
  previewSection: {
    width: widthInPercentage(50),
    position: "absolute",
    height: widthInPercentage(10),
    marginBottom: widthInPercentage(5),
    zIndex: 3,
    opacity: 300,
  },
  convertPreviewView: {
    marginRight: widthInPercentage(0),
    margingBottom: "40%",
    alignItems: "center",
  },
  editButtonView: {
    marginRight: widthInPercentage(4)
  },
  editButtonViewSection: {
    marginRight: widthInPercentage(-5)
  },
  editButtonImage: {
    height: 15,
    width: 15,
    margin: 10,
    marginRight: 0,
    marginLeft: 14,
  },
  bankDetailsSection: {
    marginHorizontal: widthInPercentage(2.5),
  },
  // thank you screen (Updatedscreen.js)
  updatedScreenModal: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
  },
  updateScreenModalView: {
    justifyContent: 'baseline',
    alignItems: 'baseline',
    paddingHorizontal: widthInPercentage(2),
  },
  ThankYouModalImage: {
    height: 20,
    width: 20,
    padding: 4
  },
  thankYouView: {
    flexDirection: 'row'
  },
  thankYouViewText: {
    paddingLeft: '4%',
    fontFamily: 'Mulish',
    justifyContent: 'center',
    //alignItems: 'center',
    //textAlign: 'center',
    fontSize: 16,
    fontFamily: 'Mulish',
    color: 'black',
  },
  thankYouDropView: {
    flexDirection: 'row',
    marginTop: '5%'
  },
  TrackServiceStyle: {
    paddingHorizontal: 10
  },
  ThankYouSection: {
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: '30%',
    marginTop: '10%',
    flex: 2,
  },
  thankYouSectionView: {
    width: widthInPercentage(50),
    position: 'absolute',
    marginTop: widthInPercentage(2),
    height: widthInPercentage(10),
    marginBottom: widthInPercentage(25),
    zIndex: 3,
  },
  thankYouTable: {
    width: '100%',
    marginLeft: 0,
    marginBottom: 10,
  },
  thankYouTableStyle: {
    width: "97%",
    marginLeft: 0
  },
  ssyTableStyles: {
    width: '95%',
    marginHorizontal: 5,
    marginTop: '10%',
  },
  updateButtonSection: {
    paddingTop: 15,
    flexDirection: 'row',
    justifyContent: 'center',
    alignContent: 'center',
  },
  updatedButtonSectionView: {
    marginHorizontal: widthInPercentage(5)
  },
  updateButtonStyle: {
    backgroundColor: '#e77817',
  },
  sendTextView: {
    marginTop: '2%',
  },
  sendTxtColor: {
    color: 'red'
  },
  transactionSelectedText:{
    width:'960px',
    marginHorizontal:'auto',
    textAlign:'right',
    paddingTop: '15px',
    paddingBottom: '15px',
    paddingLeft: '45px',
    textAlign:'right',
    marginTop:'0px',
    fontSize:'16px',
    fontWeight:'bold',
  },
  transactionSelectedText_LDPI:{
    textAlign:'center',
    marginLeft:'0%',
    marginRight:'0%',
    paddingLeft: '15px',
   },
   transactionSelectedText_MDPI:{
    textAlign:'center',
    marginLeft:'0%',
    marginRight:'0%',
    paddingLeft: '15px',
   },
   transactionSelectedText_HDPI:{
    textAlign:'center',
    marginLeft:'0%',
    marginRight:'0%',
    paddingLeft: '15px',
   },
  transactionEMIText:{
    marginLeft:'13.6%',
    padding:'15px',
    marginTop:'0px',
    fontSize:'16px',
    fontWeight:'bold',
  },
  transactionEMIText_LDPI:{
    marginLeft:'0px',
    padding:'15px',
    marginTop:'0px',
    fontSize:'13px',
    fontWeight:'bold',
    textAlign:'center'
  },
  transactionEMIText_MDPI:{
    marginLeft:'0px',
    padding:'7px',
    marginTop:'0px',
    fontSize:'15px',
    fontWeight:'bold',
    textAlign:'center'
  },
  transactionEMIText_HDPI:{
    marginLeft:'0px',
    padding:'14px',
    marginTop:'0px',
    fontSize:'15px',
    fontWeight:'bold',
    textAlign:'center'

  },
  transactionEMIText_XXHDPI:{
    marginLeft:'0px',
    padding:'15px',
    marginTop:'0px',
    fontSize:'16px',
    fontWeight:'bold',
  },
  TableTextStyle: {
    padding:"4px",
    fontWeight:"bold",
    textAlign:"center",
    justifyContent:"center",
    alignItems:"center"
  },
  descDataStyles: {
    justifyContent: 'center',
    fontSize: 23,
    padding: '1.3%',
    marginLeft: '-12px',
  },
  descDataHeader: {
    justifyContent: 'center',
    fontSize: 23,
    padding: '1.3%',
    marginLeft: '-2px',
  },
  descDataStyles_LDPI: {
    fontSize: 20,
    padding: '0%',
    marginLeft: '0px',
    marginTop: '5%'
  },
  descDataStyles_MDPI: {
    fontSize: 20,
    padding: '0%',
    marginLeft: '0px',
    marginTop: '5%'
  },
  descDataStyles_HDPI: {
    fontSize: 20,
    padding: '0%',
    margin: '0px',
    marginBottom: '2%'
  },
  descDataStyles_XHDPI: {
    fontSize: 20,
    padding: '0%',
    marginLeft: '0px',
    marginBottom: '2%'
  },
  descDataStyles_XXHDPI: {
    fontSize: 20,
    padding: '0%',
    marginLeft: '0px',
    marginBottom: '2%'
  },
  descDataStyles_XXXHDPI: {
    fontSize: 20,
    padding: '0%',
    marginLeft: '0px',
    marginBottom: '2%'
  },
  notesList:{
    fontSize: 12,
    width:'920px',
    marginHorizontal:'auto'
  },
  notesList_LDPI:{ fontSize: 12, width:'100%', marginHorizontal:'auto' },
  notesList_MDPI:{ fontSize: 12, width:'100%', marginHorizontal:'auto' },
  notesList_HDPI:{ fontSize: 12, width:'100%', marginHorizontal:'auto' },
  notesList_XXHDPI:{ fontSize: 12, width:'100%', marginHorizontal:'auto' },
  notesListText:{ display: 'block' },
  notesListText_LDPI:{ display: 'block' },
  notesListText_MDPI:{ display: 'block' },
  notesListText_HDPI:{ display: 'block' },
  notesListText_XXHDPI:{ display: 'block' },
  cardDetailText: {
    width:'920px',
    marginHorizontal:'auto',
    marginVertical:' 20px'
  },
  cardDetailText_LDPI: { width:'100%', marginHorizontal:'auto', marginVertical:' 20px' },
  cardDetailText_MDPI: { width:'100%', marginHorizontal:'auto', marginVertical:' 20px' },
  cardDetailText_HDPI: { width:'100%', marginHorizontal:'auto', marginVertical:' 20px' },
  cardDetailText_XXHDPI: { width:'100%', marginHorizontal:'auto', marginVertical:' 20px' },
  noteText: { marginHorizontal: widthInPercentage(10), marginTop: widthInPercentage(2) },
  noteText_LDPI: { marginHorizontal: widthInPercentage(0), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  noteText_MDPI: { marginHorizontal: widthInPercentage(0), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  noteText_HDPI: { marginHorizontal: widthInPercentage(8), marginTop: widthInPercentage(2), width: widthInPercentage(100) },
  notetextStyle: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    fontSize: 25,
    fontFamily: 'Mulish',
    color: 'black',
    fontWeight:650
  },
  gstinNoteText:{
    marginTop:'9%'
  }
});
